import {Component} from '@angular/core';
import {CountsPerPalletTypeGridViewDto} from "@services";
import {PalletCountType} from "@services/web-api-client";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule,
    DxTabsModule
} from "devextreme-angular";
import {FilterConfig, GridPageComponent} from "../../../common/grid-page.component";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";

@Component({
    selector: 'app-counts-per-pallet-type',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        DxTabsModule,
        FilterPanelComponent
    ],
    templateUrl: './counts-per-pallet-type.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class CountsPerPalletTypeComponent extends GridPageComponent<CountsPerPalletTypeGridViewDto> {

    constructor() {
        super();
        this.init(CountsPerPalletTypeGridViewDto);
    }

    readonly numberFormat = "#,##0";

    taskPanelItems = [
        { text: 'Full', value: PalletCountType.Full },
        { text: 'Partial', value: PalletCountType.Partial },
        { text: 'HALB', value: PalletCountType.HALB },
    ];
    selectedIndex = 0;
    selectedCountType = this.taskPanelItems[0].value;

    dataSource = this.dataSources.countsPerPalletType(this.selectedCountType);

    async tabValueChange(e: any) {
        this.selectedIndex = e.itemIndex;
        this.selectedCountType = e.itemData.value;
        this.dataSource = this.dataSources.countsPerPalletType(this.selectedCountType);
        await this.dataGrid.instance.refresh();
    }

    protected override exportName: string = "CountsPerPalletType";

    protected override filterConfig: FilterConfig[] = [
        {field: 'date', op: '>='},
        {field: 'bars', op: '>='},
        {field: 'seasonal', op: '>='},
        {field: 'nescafe', op: '>='},
        {field: 'beverage', op: '>='},
        {field: 'starbucksCpg', op: '>='},
        {field: 'infant', op: '>='},
        {field: 'nhs', op: '>='},
        {field: 'specialtyFoods', op: '>='},
        {field: 'npImport', op: '>='},
        {field: 'starbucksFs', op: '>='},
        {field: 'water', op: '>='},
        {field: 'iceCream', op: '>='},
        {field: 'others', op: '>='},
    ];
}
